import { render, staticRenderFns } from "./Securities.vue?vue&type=template&id=6a074d70&scoped=true&"
import script from "./Securities.vue?vue&type=script&lang=ts&"
export * from "./Securities.vue?vue&type=script&lang=ts&"
import style0 from "./Securities.vue?vue&type=style&index=0&id=6a074d70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a074d70",
  null
  
)

export default component.exports